import React, { createContext } from 'react'
import useRawState from '../hooks/useRawState'

const TestCategoryGroupsContext = createContext()

function TestCategoryGroupsProvider({
    ...props
}) {
    const v = useRawState('/api/current/test-category-groups')
    return (
        <TestCategoryGroupsContext.Provider
            {...props}
            value={v}
        />
    )
}

export default TestCategoryGroupsContext
export { TestCategoryGroupsProvider }
